var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPortalEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n\n      .b, .c {\n        fill: #fff;\n      }\n\n      .d {\n        fill: #6f3d90;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 150,
    cy: 150,
    r: 120
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 171.67,
    width: 75.02,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 182.15,
    width: 75.02,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 192.82,
    width: 75.02,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 152.59,
    width: 75.02,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 163.43,
    width: 75.02,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 135.24,
    y: 112.37,
    width: 23.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 135.24,
    y: 123.03,
    width: 36.32,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 141.93,
    width: 41.27,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M200.35,80h-100.69c-3.22,0-5.84,2.62-5.84,5.84v128.32c0,3.22,2.62,5.84,5.84,5.84h100.69c3.22,0,5.84-2.62,5.84-5.84V85.84c0-3.22-2.62-5.84-5.84-5.84ZM204.54,214.16c0,2.31-1.88,4.19-4.19,4.19h-100.69c-2.31,0-4.19-1.88-4.19-4.19V85.84c0-2.31,1.88-4.19,4.19-4.19h100.69c2.31,0,4.19,1.88,4.19,4.19v128.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.82,204.91h94.37v-108.87h-94.37v108.87ZM195.53,97.68v105.57h-91.06v-105.57h91.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 141.53,
    y: 87.97,
    width: 16.93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 144.54,
    y: 210.64,
    width: 10.93,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 112.37,
    width: 12.38,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 123.03,
    width: 12.38,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.67,
    y: 163.26,
    width: 75.02,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 112.49,
    y: 171.49,
    width: 75.02,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPortalEmail);
export default __webpack_public_path__ + "static/media/admin_portal_email.229e79b0fb59243f6edf3c28463ba100.svg";
export { ForwardRef as ReactComponent };